// store/modules/global.js
const globalStore = {
  state: {
    loader: {
      isLoading: false,
      message: ''
    },
    alerts: [],
    tip: {
      currentTip: null
    },
    modals: []
  },
  mutations: {
    setLoading(state, { isLoading, message = '' }) {
      state.loader.isLoading = isLoading
      state.loader.message = message
    },
    addAlert(state, alert) {
      state.alerts.push({
        type: 'info',
        ...alert
      })
      
      // Auto remove after 5 seconds
      if (alert.timeout !== false) {
        setTimeout(() => {
          state.alerts.shift()
        }, alert.timeout || 5000)
      }
    },
    removeAlert(state, index) {
      state.alerts.splice(index, 1)
    },
    showTip(state, tip) {
      state.tip.currentTip = tip
      
      if (tip.duration) {
        setTimeout(() => {
          state.tip.currentTip = null
        }, tip.duration)
      }
    },
    clearTip(state) {
      state.tip.currentTip = null
    },
    openModal(state, modal) {
      state.modals.push(modal)
    },
    closeModal(state, index) {
      state.modals.splice(index, 1)
    }
  },
  actions: {
    showAlert({ commit }, alert) {
      commit('addAlert', alert)
    },
    showTip({ commit }, tip) {
      commit('showTip', tip)
    },
    openModal({ commit }, modal) {
      commit('openModal', modal)
    },
    closeModal({ commit }, index) {
      commit('closeModal', index)
    }
  }
}

export default globalStore